export function roundDecimals(num) {
    return parseFloat(Math.round(num * 100) / 100).toFixed(2)
}

export function addLeadingZero(n) {
    if (n <= 9) {
        return "0" + n
    }
    return n
}

export function formatDate(date) {
    var d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();

    if (month.length < 2)
        month = '0' + month;
    if (day.length < 2)
        day = '0' + day;

    return [year, month, day].join('-');
}

export function uniqueBy(arr, prop){
    return arr.reduce((a, d) => {
        if (!a.includes(d[prop])) { a.push(d[prop]); }
        return a;
    }, []);
}

export function purchaseOrderStatus(statusID) {
    let status = 'Ordered';
    switch (statusID) {
        case 10:
            status = 'Cancelled';
            break;
        case 20:
            status = 'Draft';
            break;
        case 30:
            status = 'Ordered';
            break;
        case 40:
            status = 'Partially Filled';
            break;
        case 50:
            status = 'Filled';
            break;
        default:
            status = 'Ordered';
    }
    return status;
}

export function capitalize(string) {
    if (typeof(string) == "undefined") {
        return '';
    }
    if (string.length === 0) {
        return '';
    }
    return string[0].toUpperCase() + string.slice(1)
}

export function isExternalWarehouse(warehouseType) {
    return warehouseType === 20;
}

export function validValue(value, zeroAsBlank = false) {
	value = parseInt(value);
	if (isNaN(value) || value <= 0) {
		value = zeroAsBlank ? '' : 0;
	}
    return value;
}